import { pageTitle } from "../content";
import { defaultTitle, siteUrl } from "../data/site";
import { teamMemberAt } from "../data/team";

/** Shared by static HTML generation and enhanced in-document navigation. */
export function pageMetadata(page) {
  const member = teamMemberAt(page.path);
  const title =
    page.path === "/"
      ? defaultTitle
      : member
        ? `${member.fullName || member.name}, ${member.title} | Xeratec`
        : `${pageTitle(page)} | Xeratec`;
  return {
    title,
    description:
      page.description ||
      "Custom software and practical technology guidance from Xeratec.",
    canonical: siteUrl + page.path.replace(/\d+\/$/, ""),
    ogDescription: page.description || "Software built around your business.",
    image: page.image,
  };
}
